import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useQueryString } from "hooks/general-hooks";
import { getSpecIcon } from "lib/iconHelpers";
import {
  getHeroTalentIconURL,
  getHeroTalentQueryParamFormat,
  getHeroNameFromSelectedTree,
  getSpecTreeAccessor,
} from "lib/wowHelpers";
import { getClassColor } from "../../../lib/wowHelpers";

const SpecLink = (props) => {
  const { data, encounterType, isMobileSmall } = props;

  const params = useQueryString();
  const classUrl = getSpecTreeAccessor(data.class);
  const specUrl = getSpecTreeAccessor(data.spec);
  const classColor = getClassColor(data.display_name);
  const linkEncounter = encounterType === "mythic" ? "" : "/" + encounterType;

  const query = useMemo(() => {
    if ("encounter" in params && params["encounter"] === "all_bosses") {
      delete params["encounter"];
    }

    // Remove any existing hero params
    if ("hero" in params) {
      delete params["hero"];
    }

    if ("hscombined" in params) {
      delete params["hscombined"];
    }

    if (data.subspec_display_name == null) {
      const heroSpecDefault = getHeroNameFromSelectedTree("left", data.display_name, data.spec_display_name);
      params["hero"] = getHeroTalentQueryParamFormat(heroSpecDefault);
    } else {
      params["hero"] = getHeroTalentQueryParamFormat(data.subspec_display_name);
    }

    return Object.keys(params)
      .map((k) => `${k}=${params[k]}`)
      .join("&");
  }, [params]);

  const linkPathName =
    encounterType === "pvp" ? `/wow/${specUrl}/${classUrl}/pvp` : `/wow/${specUrl}/${classUrl}/talents${linkEncounter}`;
  return (
    <Link
      className="spec-link"
      to={{
        pathname: linkPathName,
        search: query,
      }}
    >
      <div className="spec-container" style={{ color: `${classColor}` }}>
        <div className="spec-icon">
          <img
            style={{ filter: "brightness(1.25)", width: "30px", height: "30px" }}
            src={getSpecIcon(data.class, data.spec)}
            width={30}
            height={30}
            alt={data.subspec_display_name + " " + data.spec + " " + data.class}
          />
          {data.subspec_display_name == null ? (
            <div></div>
          ) : (
            <img
              src={getHeroTalentIconURL(data.subspec_display_name)}
              style={{ filter: "brightness(1.25)", width: "30px", height: "30px", marginLeft: "10px" }}
              className="hero-icon"
              alt={data.subspec_display_name}
            />
          )}
        </div>
        {!isMobileSmall && (
          <div className="hero-and-spec-name">
            {data.subspec_display_name == null ? (
              <div>
                <div className="no-hero-spec-name">
                  {data.spec_display_name} {data.display_name}
                </div>
              </div>
            ) : (
              <div>
                <div className="hero-name">{data.subspec_display_name}</div>
                <div className="spec-name">
                  {data.spec_display_name} {data.display_name}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </Link>
  );
};

export default SpecLink;
